module.exports = __webpack_public_path__ + "img/l3.00442635.png";